import type { Item, SingleVariantOfferItem } from '../SelectItems.types'

export const isSingleVariantOfferItemType = (
  item: Item,
): item is Extract<Item, SingleVariantOfferItem> => item.type === 'SINGLE_VARIANT_OFFER'
